// This file is automatically compiled by esbuild, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from '@rails/ujs'
import * as ActiveStorage from '@rails/activestorage'
import documentReady from '../common/documentReady.ts'
import benefitsPopUps from '../common/benefits-pop-ups.ts'
import photo from '../common/photo'
import navBar from '../common/nav-bar.ts'
import prepareSearch from '../common/search.js'
import productQuantity from '../common/product-quantity.ts'
import hubboxCollectPoint from '../common/hubboxCollectPoint.ts'
import positionStickyButtons from '../common/sticky_button.js'

Rails.start()
ActiveStorage.start()

// require('@rails/ujs').start();
require('../common/default')
require('../common/submit_on_change')
require('../common/googleEventTracking.ts')
require('../common/mobile-site-notice')
require('../common/optIn')

require('../metal_store/customTubeCuttingBar.ts')

documentReady(() => {
  prepareSearch()
  productQuantity()
  navBar()
  benefitsPopUps()
  positionStickyButtons()
  hubboxCollectPoint()

  photo('.gallery figure > a')
  photo('.product-image a')
  photo('a.enlarge')
})
